// extracted by mini-css-extract-plugin
export var alt = "ParagraphHistory-module--alt--ed244";
export var container = "ParagraphHistory-module--container--4aa4d";
export var desktopOnly = "ParagraphHistory-module--desktopOnly--e6e9f";
export var main = "ParagraphHistory-module--main--dcfc9";
export var mobileOnly = "ParagraphHistory-module--mobileOnly--f0847";
export var textLeft = "ParagraphHistory-module--textLeft--bf008";
export var visuallyHidden = "ParagraphHistory-module--visuallyHidden--78502";